import styled, { css } from "styled-components";
import { Link } from "react-router-dom";

export const LinkContainer = styled(Link)`
  text-decoration: none;
  color: inherit;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  ${({ theme }) =>
    css`
      background-color: ${theme.colorTokens.background.surface};
      padding: ${theme.space["space-3"]} ${theme.space["space-6"]};
    `}
`;

export const IconContainer = styled.div`
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 48px;
  width: 48px;
  border-radius: 50%;
  ${({ theme }) =>
    css`
      margin: 0 0 ${theme.space["space-4"]};
      background-color: ${theme.colorTokens.background.surface};
      border: 1px solid ${theme.colorTokens.border.default};
    `}
`;
